import { Framework } from '@merchant-portal/framework';
import { Themes, UIThemeProvider } from '@klarna/mp-ui';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { hooks as coreHooks } from 'mage-core';
import { LanguageSelector } from 'moet-core';

import { thunks as stateThunks } from 'mage-state';
import { selectors as i18nSelectors } from 'mage-i18n';

import { isNewSplitLayout, getMerchant } from '@/selectors/merchant';
import { IS_ONBOARDING_APP } from '@/constants';
import { isWidget } from '@/selectors/widget';

function MarbleFramework(props) {
  const {
    children,
    featureTour,
    footerConfig,
    hideSidebar,
    isNewSplitLayout,
    isWidget,
    sidePanel,
    topBarConfig,
  } = props;
  const [isAppPublic, setOnBoardingApp] = useState(isWidget || IS_ONBOARDING_APP);
  const sidebarConfig = isAppPublic ? { items: [] } : props?.sidebarConfig;
  const selectedLanguage = useSelector(i18nSelectors.language);
  const dispatch = useDispatch();

  let userId;
  if (!isAppPublic) {
    const tokenHelper = coreHooks.useTokenHelper();
    userId = tokenHelper?.getUserId();
  }

  const saveLanguage = language => {
    dispatch(stateThunks.saveLanguage(userId, language));
  };

  const userMenu = topBarConfig?.actionButtons?.find(button => button.key === 'user-button');
  const customActionButtons = isAppPublic
    ? [
        <LanguageSelector
          key={selectedLanguage}
          language={selectedLanguage}
          saveLanguage={saveLanguage}
        />,
      ]
    : hideSidebar
    ? [userMenu]
    : undefined;

  useEffect(() => {
    setOnBoardingApp(isWidget || IS_ONBOARDING_APP);
  }, [IS_ONBOARDING_APP, isWidget]);

  const shouldRenderSidePanel = !customActionButtons;
  const defaultActionButtons = topBarConfig?.actionButtons || [];
  const actionButtons = customActionButtons || defaultActionButtons;

  return (
    <UIThemeProvider theme={Themes.Marble}>
      <Framework
        featureTour={featureTour}
        footerConfig={footerConfig}
        id="mp-app-framework"
        isFullScreenContent={isNewSplitLayout}
        sidebarConfig={sidebarConfig}
        sidePanel={shouldRenderSidePanel && sidePanel}
        topBarConfig={{
          ...topBarConfig,
          actionButtons,
        }}
      >
        {Array.isArray(children) ? children : [children]}
      </Framework>
    </UIThemeProvider>
  );
}

MarbleFramework.propTypes = {
  hideSidebar: PropTypes.bool.isRequired,
  isNewSplitLayout: PropTypes.bool.isRequired,
  isWidget: PropTypes.bool.isRequired,
  children: PropTypes.node,
  featureTour: PropTypes.object,
  footerConfig: PropTypes.object,
  sidebarConfig: PropTypes.object,
  sidePanel: PropTypes.object,
  topBarConfig: PropTypes.shape({
    actionButtons: PropTypes.arrayOf(PropTypes.node),
  }),
};

const MoetFramework = props => {
  const { children, isNewSplitLayout, merchant, isWidget, ...rest } = props;

  return isNewSplitLayout ? (
    <>{children}</>
  ) : (
    <MarbleFramework {...rest}>{children}</MarbleFramework>
  );
};

MoetFramework.propTypes = {
  isNewSplitLayout: PropTypes.bool.isRequired,
  isWidget: PropTypes.bool.isRequired,
  children: PropTypes.node,
  merchant: PropTypes.object,
};

export default connect(state => ({
  isNewSplitLayout: isNewSplitLayout(state),
  isWidget: isWidget(state),
  merchant: getMerchant(state),
}))(MoetFramework);
